import { SIP_STATUS_DETAILS } from "../strings/portfolio"
const COMMON_PF_MFP_STATUS_CODES = {
  kycPending: 308,
  firstInvestment: 312,
  success: 200,
};

export const PORTFOLIO_LANDING_STATUS_CODES = {
  downtime: 313,
  mfFailed: 314,
  stocksFailed: 315,
  npsFailed: 319,
  stocksNpsFailed: 316,
  onlyInsuranceInvested: 309,
  noInvestment: 310,
  ...COMMON_PF_MFP_STATUS_CODES,
};

export const MF_PORTFOLIO_LANDING_STATUS_CODE = {
  noInvestment: 311,
  investmentRedeemed: 320,
  freshInvestment: 321,
  mfFailed: 318,
  mfExternalPortfolioFailed: 317,
  ...COMMON_PF_MFP_STATUS_CODES,
};

export const PORTFOLIO_LANDING_SCREEN_ID = {
  [PORTFOLIO_LANDING_STATUS_CODES.downtime]: "portfolioLandingDownTime",
  [PORTFOLIO_LANDING_STATUS_CODES.stocksFailed]: "portfolioUnableToLoad",
  [PORTFOLIO_LANDING_STATUS_CODES.npsFailed]: "portfolioUnableToLoadInvestment",
  [PORTFOLIO_LANDING_STATUS_CODES.stocksNpsFailed]:
    "portfolioUnableToLoadInvestment",
  [PORTFOLIO_LANDING_STATUS_CODES.success]: "portfolioLanding",
};

export const MF_PORTFOLIO_LANDING_SCREEN_ID = {
  [MF_PORTFOLIO_LANDING_STATUS_CODE.success]: "mutualFundPortfolio",
  [MF_PORTFOLIO_LANDING_STATUS_CODE.mfExternalPortfolioFailed]:
    "externalFailed",
};

export const EXTERNAL_PORTFOLIO_STATUS = {
  init: "init",
  pending: "pending",
  failed: "failed",
  trigger_failed: "trigger_failed",
  success: "success",
};

const EXTERNAL_PORTFOLIO_MF_SCREEN_ID = {
  [EXTERNAL_PORTFOLIO_STATUS.pending]: "externalProgress",
  [EXTERNAL_PORTFOLIO_STATUS.failed]: "externalInvalid",
  [EXTERNAL_PORTFOLIO_STATUS.trigger_failed]: "externalRetrigger",
  [EXTERNAL_PORTFOLIO_STATUS.success]: "externalConnected",
};

export const getMutualFundScreenId = (
  externalPortfolioStatus,
  mfStatusCode,
  isAllInvestmentRedeemed
) => {
  if (isAllInvestmentRedeemed) {
    return "mutualFundPortfolioAfterRedeem";
  }
  let externalMfScreenId =
    EXTERNAL_PORTFOLIO_MF_SCREEN_ID[externalPortfolioStatus] || "";
  if (!externalMfScreenId) {
    externalMfScreenId =
      MF_PORTFOLIO_LANDING_SCREEN_ID[mfStatusCode] ||
      MF_PORTFOLIO_LANDING_SCREEN_ID[MF_PORTFOLIO_LANDING_STATUS_CODE.success];
  }
  return externalMfScreenId;
};

export const getPortfolioLandingErrorStates = (statusCode) => {
  const {
    mfFailed,
    firstInvestment,
    noInvestment,
    kycPending,
    downtime,
    stocksFailed,
    stocksNpsFailed,
    npsFailed,
  } = PORTFOLIO_LANDING_STATUS_CODES;
  const ShowNoInvestmentPendingStatus = [noInvestment, kycPending];
  const isMfFailed = statusCode === mfFailed;
  const isNoInvestment = ShowNoInvestmentPendingStatus.includes(statusCode);
  const isFirstInvestment = statusCode === firstInvestment;
  const isDownTime = downtime === statusCode;
  const isStocksFailed = stocksFailed === statusCode;
  const isStocksNpsFailed = [npsFailed, stocksNpsFailed].includes(statusCode);
  return {
    isMfFailed,
    isNoInvestment,
    isFirstInvestment,
    isDownTime,
    isStocksFailed,
    isStocksNpsFailed,
  };
};

export const getMfPortfolioLandingErrorStates = (statusCode) => {
  const {
    investmentRedeemed,
    firstInvestment,
    noInvestment,
    kycPending,
    mfFailed,
    mfExternalPortfolioFailed,
	freshInvestment
  } = MF_PORTFOLIO_LANDING_STATUS_CODE;
  const isAllInvestmentRedeemed = statusCode === investmentRedeemed;
  const ShowNoInvestmentPendingStatus = [noInvestment, kycPending];
  const isNoInvestment = ShowNoInvestmentPendingStatus.includes(statusCode);
  const isFirstInvestment = statusCode === firstInvestment;
  const isFreshInvestment = statusCode === freshInvestment;
  const isMfFailed = statusCode === mfFailed;
  const isMfExternalPortfolioFailed = statusCode === mfExternalPortfolioFailed;
  return {
    isMfFailed,
    isNoInvestment,
    isFirstInvestment,
    isAllInvestmentRedeemed,
    isMfExternalPortfolioFailed,
	  isFreshInvestment
  };
};

const PORTFOLIO_UPDATING_NO_INVESTMENT = {
  portfolio: {
    updating: {
      screenDataAid: "portfolioUpdating",
      navHeader: {
        title: "Portfolio",
        dataAid: "portfolioUpdating",
      },
      landingHeader: {
        dataAid: "updatingShortly",
        title: "Updating shortly...",
        subtitle: "Your investments will start to appear here in a while",
      },
      cta: {
        title: "VIEW ORDERS",
        dataAid: "primary",
      },
    },
    noInvestments: {
      screenDataAid: "portfolioEmptyKYC",
      navHeader: {
        title: "Portfolio",
        dataAid: "portfolioEmptyKYC",
      },
      landingHeader: {
        dataAid: "noInvestments",
        title: "No investments yet!",
        subtitle:
          "Join 5M+ Indians who invest their money to grow their money. Returns from investments help to build wealth with no sweat!",
      },
      cta: {
        title: "START KYC",
        dataAid: "primary",
      },
    },
  },
  mf: {
    updating: {
      screenDataAid: "mutualFundPortfolioUpdating",
      navHeader: {
        title: "Mutual funds",
        dataAid: "mutualFundUpdating",
      },
      landingHeader: {
        dataAid: "updatingShortly",
        title: "Updating shortly...",
        subtitle: "Your investments will start to appear here in a while",
      },
      cta: {
        title: "VIEW ORDERS",
        dataAid: "primary",
      },
    },
    noInvestments: {
      screenDataAid: "mutualFundPortfolioEmptyKYC",
      navHeader: {
        title: "Mutual funds",
        dataAid: "mutualFundEmpty",
      },
      landingHeader: {
        dataAid: "noInvestments",
        title: "No investments yet!",
        subtitle:
          "Join 5M+ Indians who invest their money to grow their money. Returns from investments help to build wealth with no sweat!",
      },
      cta: {
        title: "START KYC",
        dataAid: "primary",
      },
    },
    investmentRedeemed: {
      screenDataAid: "mutualFundPortfolioAfterRedeem",
      navHeader: {
        title: "Mutual funds",
        dataAid: "mutualFundEmpty",
      },
      landingHeader: {
        dataAid: "noInvestments",
        title: "No active investments",
        subtitle:
          "It seems you’ve redeemed all your mutual fund investments due to which you’re not able to view them here",
      },
      cta: {
        title: "INVEST AGAIN",
        dataAid: "primary",
      },
    },
  },
  nps: {
    noInvestments: {
      screenDataAid: "npsEmptyStartInvesting",
      navHeader: {
        title: "NPS",
        dataAid: "npsEmpty",
      },
      landingHeader: {
        dataAid: "noInvestments",
        title: "No investments yet!",
        subtitle:
          "Join 5M+ Indians who invest their money to grow their money. Returns from investments help to build wealth with no sweat!",
      },
      cta: {
        title: "START INVESTING",
        dataAid: "primary",
      },
    },
  },
};

export const getPendingNoInvestmentScreenData = (
  screenName,
  status,
  isInvestmentReady
) => {
  const screenData = PORTFOLIO_UPDATING_NO_INVESTMENT[screenName][status];
  const isMfScreen = screenName === "mf";
  const isNpsScreen = screenName === "nps";
  const isNoInvestment = status === PENDING_NO_INVESTMENT_STATUS.noInvestments;
  const isUpdateInProgress = status === PENDING_NO_INVESTMENT_STATUS.updating;
  const isInvestmentRedeemed =
    status === PENDING_NO_INVESTMENT_STATUS.investmentRedeemed;
  const shouldUpdateNoInvestmentCta =
    isInvestmentReady && isNoInvestment && !isInvestmentRedeemed;
  if (shouldUpdateNoInvestmentCta && !isNpsScreen) {
    screenData.cta.title = "START INVESTING";
  }
  if (shouldUpdateNoInvestmentCta && !isMfScreen && !isNpsScreen) {
    screenData.cta.title = "INVEST NOW";
  }
  if (isInvestmentReady && isMfScreen && !isUpdateInProgress) {
    screenData.screenDataAid = "mutualFundPortfolioEmptyStartInvesting";
  }
  return screenData;
};

export const PENDING_NO_INVESTMENT_STATUS = {
  updating: "updating",
  noInvestments: "noInvestments",
  investmentRedeemed: "investmentRedeemed",
};

export const MORE_OPTIONS = [
  {
    key: "sipManager",
    title: "SIP manager",
    dataAid: "sipManager",
    walkThroughText: "Click here to view & manage your SIPs",
  },
  {
    key: "yourFunds",
    title: "My funds",
    dataAid: "yourFunds",
    walkThroughText:
      "Click here to view existing investments & fund performance",
  },
  {
    key: "goalTracker",
    title: "Goal tracker",
    dataAid: "goalTracker",
    walkThroughText: "Click here to track & manage your goals",
  },
  {
    key: "yourOrders",
    title: "My orders",
    dataAid: "yourOrders",
    walkThroughText: "Click here to view & track your order status",
  },
  {
    key: "withdraw",
    title: "Withdraw",
    dataAid: "withdraw",
    walkThroughText: "Click here to withdraw funds",
  },
];

const EXTERNAL_PORTFOLIO_PRODUCT_MAPPER = {
	fisdom: {
		name: 'Fisdom',
		email: 'cas@fisdom.com'
	},
	finity: {
		name: 'Finity',
		email: 'cas@finity.in'
	}
};

const ExternalPortfolioStatus = (productType) => {
	const { name, email } = EXTERNAL_PORTFOLIO_PRODUCT_MAPPER[productType];
	return {
		init: {
			title: "Import external portfolio",
			subtitle: `Track & manage all your ${name} & non-${name} investments in one place`,
		},
		pending: {
			title: "Import external portfolio",
			status: "Pending on you",
			subtitle: `Forward CAS email to ${email}`,
			statusColor: "foundationColors.secondary.coralOrange.400"
		},
		failed: {
			title: "Import external portfolio",
			status: "Invalid CAS",
			subtitle: `Tap to regenerate CAS & forward it to ${email}`,
		},
		trigger_failed: {
			title: "Import external portfolio",
			status: "Unable to generate CAS",
			subtitle: `Tap to regenerate CAS & forward it to ${email}`,
		},
		success: {
			title: {
			text: "External portfolio",
			dataAid: "title",
			},
			keyExternalInvestments: {
			text: "External investments",
			dataAid: "keyExternalInvestments",
			},
			valueExternalInvestments: {
			dataAid: "valueExternalInvestments",
			},
			keyXirr: {
			text: "XIRR",
			dataAid: "keyXirr",
			},
			valueXirr: {
			dataAid: "valueXirr",
			},
			bottomText: {
			text: "Data as per CAS forwarded on",
			dataAid: "text",
			},
		},
	}
};

export const getExternalPortfolioData = (status, buildType) => {
  let statusData = ExternalPortfolioStatus(buildType)[status];
  statusData.dataAid = "externalPortfolio";
  return statusData;
};

export const TimeLineYearData = [
  {
    label: "1Y",
    value: 1,
  },
  {
    label: "3Y",
    value: 3,
  },
  {
    label: "5Y",
    value: 5,
  },
  {
    label: "10Y",
    value: 10,
  },
  {
    label: "15Y",
    value: 15,
  },
];

export const ToolTipMapper = {
  1: {
    text: "Estimated return is calculated based on a 100% debt allocation with a 5% rate of return",
    dataAid: "mf1Y",
  },
  3: {
    text: "Estimated return is calculated based on a 50% equity & 50% debt allocation with an 8.5% rate of return",
    dataAid: "mf3Y",
  },
  5: {
    text: "Estimated return is calculated based on a 70% equity & 30% debt allocation with a 9.9% rate of return",
    dataAid: "mf5Y",
  },
  10: {
    text: "Estimated return is calculated based on an 80% equity & 20% debt allocation with a 10.6% rate of return",
    dataAid: "mf10Y",
  },
  15: {
    text: "Estimated return is calculated based on a 90% equity & 10% debt allocation with an 11.3% rate of return",
    dataAid: "mf15Y",
  },
  stocks: {
    text: "Estimated return is calculated using a 12% rate of return",
    dataAid: "stocks",
  },
};

export const AssetReturnPercentage = {
  1: {
    debt: 100,
    equity: 0,
  },
  3: {
    debt: 50,
    equity: 50,
  },
  5: {
    debt: 30,
    equity: 70,
  },
  10: {
    debt: 20,
    equity: 80,
  },
  15: {
    debt: 10,
    equity: 90,
  },
};

export const getEstimatedReturn = (investedValue, year, investmentCategory) => {
  let returnPercentage = 0;
  let estimatedValue = 0;
  if (investmentCategory === "mutual_funds") {
    const { debt, equity } = AssetReturnPercentage[year];
    returnPercentage =
      ((debt / 100) * (5 / 100) + (equity / 100) * (12 / 100)) * 100;
    returnPercentage = returnPercentage.toFixed(2);
  } else {
    returnPercentage = 12; // hardcoded for stocks.
  }
  const returnValuePer = 1 + returnPercentage / 100;
  estimatedValue = investedValue * Math.pow(returnValuePer, year);
  return {
    estimatedValue,
    returnPercentage,
  };
};

export const AllocationTypes = {
  sector_allocation: {
    title: "Sectors",
    ctaTitle: "View all sectors",
  },
  top_holdings: {
    title: "Holdings",
    ctaTitle: "View all holdings",
  },
};

export const AllocationCategories = {
  Equity: "Equity",
  Debt: "Debt",
  Others: "Others",
};

export const AllocationTabs = [
  {
    title: AllocationCategories.Equity,
    key: "equity",
    dataAid: "equity",
  },
  {
    title: AllocationCategories.Debt,
    key: "debt",
    dataAid: "debt",
  },
  {
    title: AllocationCategories.Others,
    key: "others",
    dataAid: "others",
  },
];

export const ReturnCalculatorInvestmentTypes = {
  stocks: "stocks",
  mutualFunds: "mutual_funds",
};

export const ReturnCalculatorDefaultValues = {
  sliderMinValue: 1000,
  sliderMaxValue: 12000,
  sliderValue: 5000,
  investmentCategory: ReturnCalculatorInvestmentTypes.mutualFunds,
  selectedYear: 3,
};

export const ReturnCalculatorScreenNames = {
  portfolio: "portfolio",
  mf: "mf",
};

export const EmptyStates = {
  noSip: {
    pageTitle: "SIP manager",
    dataAid: "noSIP",
    title: "You have no SIPs yet",
    subtitle:
      "When you start investing in SIPs, you’ll be able to view & manage them from here",
    buttonTitle: "INVEST NOW",
    buttonDataAid: "investNow",
  },
  noHoldings: {
    pageTitle: "SIP manager",
    title: "No holdings yet",
    subtitle:
      "When you invest in mutual funds, your holdings will start to appear here",
  },
  noGoals: {
    pageTitle: "Goal tracker",
    title: "You haven’t set any goals yet",
    subtitle:
      "When you pick a goal & start investing towards it, you’ll be able to view the progress of your goals here",
  },
  noTransaction: {
    pageTitle: "Transactions",
    title: "No transactions to show",
    subtitle:
      "When you start investing, you’ll find your complete transaction list here",
  },
  noOrders: {
    pageTitle: "Order book",
    title: "You haven’t placed any orders yet",
    subtitle: "Start placing orders to view them here",
  },
  noFundToWithdraw: {
    pageTitle: "Withdraw",
    title: "No funds to withdraw",
    subtitle:
      "Once you make an investment you’ll be able to view funds eligible for withdrawal",
  },
  noFunds: {
    pageTitle: "Your funds",
    dataAid: "noHoldings",
    title: "No holdings yet",
    subtitle:
      "When you invest in mutual funds, your holdings will start to appear here",
    buttonTitle: "Invest Now",
    buttonDataAid: "investNow",
  },
  somethingWrong: {
    title: "Something’s wrong",
    subtitle:
      "Currently, we’re having an issue loading your portfolio details ",
    btnTitle: "RETRY",
  },
};

export const getPortfolioErrorStatusData = (
  isDownTime = false,
  isStocksFailed = false,
  isStocksNpsFailed = false
) => {
  if (isDownTime) {
    return {
      text: "12 am to 3 am stock-specific data will be unavailable",
    };
  } else if (isStocksFailed) {
    return {
      text: "Unable to load your investments in stocks.",
      cta: "Refresh",
    };
  } else if (isStocksNpsFailed) {
    return {
      text: "Unable to load your investments.",
      cta: "Retry in a while",
    };
  } else {
    return {};
  }
};

export const SORT_DATA_LIST = [
  {
    title: "Invested",
    titleDataAid: "invested",
    value: "invested",
    contents: [
      {
        label: "High to low",
        value: "invHighToLow",
        order: "desc",
        labelDataAid: "investedList1",
        type: "invested_amount",
      },
      {
        label: "Low to high",
        value: "invLowToHigh",
        order: "asc",
        labelDataAid: "investedList2",
        type: "invested_amount",
      },
    ],
  },
  {
    title: "Current",
    titleDataAid: "current",
    value: "current",
    contents: [
      {
        label: "High to low",
        value: "currHighToLow",
        order: "desc",
        labelDataAid: "currentList1",
        type: "current_amount",
      },
      {
        label: "Low to high",
        value: "currLowToHigh",
        order: "asc",
        labelDataAid: "currentList2",
        type: "current_amount",
      },
    ],
  },
  {
    title: "XIRR",
    titleDataAid: "xirr",
    value: "xirr",
    contents: [
      {
        label: "High to low",
        value: "xirrHighToLow",
        order: "desc",
        labelDataAid: "xirrList1",
        type: "xirr",
      },
      {
        label: "Low to high",
        value: "xirrLowToHigh",
        order: "asc",
        labelDataAid: "xirrList2",
        type: "xirr",
      },
    ],
  },
];

export const FUND_TYPES = [
  {
    title: "All funds",
    dataAid: "funds",
    value: "funds",
  },
  {
    title: "ELSS",
    dataAid: "elss",
    value: "elss",
  },
  {
    title: "Debt",
    dataAid: "debt",
    value: "debt",
  },
  {
    title: "Equity",
    dataAid: "equity",
    value: "equity",
  },
  {
    title: "Hybrid",
    dataAid: "hybrid",
    value: "hybrid",
  },
];

export const BOTTOMSHEET_INFO_HOLDING_DETAILS = [
  "Current value calculated as per yesterday’s NAV",
  "Invested value = amount invested - amount withdrawn",
];
export const InvestmentEvent = {
  equity: "stocks, f&o",
  nps: "nps",
  mf: "mutual fund",
};

export const STEP_STATUS = {
  PURCHASE_SUCCESS: "purchase_success",
  UNIT_DEDUCTED: "unit_deducted",
  ORDER_PLACED: "order_placed",
  UNIT_ALLOTED: "unit_alloted",
  UNIT_SWITCHED: "unit_switched",
  WITHDRAW_SUCCESS: "withdraw_success",
  REQUEST_RAISED: "request_raised",
  PROV_UNITS_ALLOTED: "prov_units_alloted",
  SWITCH_SUCCESS: "switch_success",
  SWITCH_PLACED: "switch_placed",
};

export const PURCHASE_ORDER_TYPE = {
  sip: "SIP",
  onetime: "One-Time",
};

export const FUNDS_STATUS_VALUES = {
  purchase: "Purchase",
  divreinvest: "Dividend reinvest",
  transferin: "Change of broker", // User moving his funds/changing broker to fisdom
  redemption: "Withdraw",
  divpayout: "Dividend payout",
  transferout: "Change of broker", // User moving his funds/changing broker out of fisdom
  switch: "Switch",
  switchin: "Switch",
};

export const PURCHASE_ORDER_DETAIL_TYPE = {
  sip: "SIP",
  onetime: "One-time",
};

export const FUNDS_STATUS = [
  "purchase",
  "divreinvest",
  "transferin",
  "redemption",
  "divpayout",
  "transferout",
  "switch",
  "switchin",
];

export const TRANSACTION_TYPE = {
  PURCHASE: "purchase",
  REDEMPTION: "redemption",
  SWITCH: "switch",
  SWITCHIN: "switchin",
  DIVPAYOUT: "divpayout",
};

// bottomsheet constants for portfolio order details
export const BOTTOMSHEET_PURCHASE = [
  {
    message: `Your purchase order has been placed with us`,
  },
  {
    message:
      "Units will be allotted within 4-5 working days (excluding weekends & public holidays)",
  },
];

export const BOTTOMSHEET_WITHDRAW = (endDate = "") => [
  {
    message: `Expect the withdrawal amount in bank account within 4-5 working days`,
  },
  {
    message: `If you don’t receive the amount even after ${endDate}, contact `,
    ctaSupport: "Support",
  },
];

export const BOTTOMSHEET_SWITCH = [
  {
    message: `Switch order placed with fund house`,
  },
  {
    message:
      "Units will be allotted within 4-5 working days (excluding weekends & public holidays)",
  },
];

export const BOTTOMSHEET_MAPPER = (endDate = "") => {
  return {
    [TRANSACTION_TYPE.PURCHASE]: BOTTOMSHEET_PURCHASE,
    [TRANSACTION_TYPE.REDEMPTION]: BOTTOMSHEET_WITHDRAW(endDate),
    [TRANSACTION_TYPE.SWITCH]: BOTTOMSHEET_SWITCH,
    [TRANSACTION_TYPE.SWITCHIN]: BOTTOMSHEET_SWITCH,
  };
};

export const HOLDING_DETAILS_MENU_OPTIONS = [
  { name: "Switch fund", value: "switch" },
  { name: "Withdraw", value: "withdraw" },
];

export const YOUR_ORDERS_PILLS_OPTIONS = [
  {
    label: "In Progress",
    dataAid: "inProgress",
  },
  {
    label: "Successful",
    dataAid: "successful",
  },
];

export const INVESTTYPE_MAPPER = {
  sip: "SIP",
  onetime: "Onetime",
};

export const TRANSACTION_TYPE_MAPPER = {
  purchase: "Purchase",
  divreinvest: "Dividend reinvest",
  transferin: "Change of broker",
  redemption: "Withdraw",
  divpayout: "Dividend payout",
  transferout: "Change of broker",
  switchin: "Switch",
  switch: "Switch",
};

export const YOUR_ORDERS_FILTER_TAB_OPTIONS = [
  {
    id: 1,
    label: "Investment type",
    dataAid: "investmentType",
    value: "order_type",
  },
  { id: 2, label: "Order type", dataAid: "orderType", value: "ttype" },
  {
    id: 3,
    label: "Category",
    dataAid: "category",
    value: "fisdom_category_v2",
  },
];

export const YOUR_ORDERS_FILTER_TAB = {
  investmentType: {
    text: "Investment type",
    value: "order_type",
    dataAid: "investmentType",
  },
  orderType: {
    text: "Order type",
    value: "ttype",
    dataAid: "orderType",
  },
  category: {
    text: "Category",
    value: "fisdom_category_v2",
    dataAid: "category",
  },
};

export const ORDER_TYPES = [
  {
    label: "Switch",
    value: "switch",
    dataAid: "switch",
  },
  {
    label: "Purchase",
    value: "purchase",
    dataAid: "purchase",
  },
  {
    label: "Withdraw",
    value: "redemption",
    dataAid: "withdraw",
  },
];

export const CATEGORIES = [
  {
    label: "Equity",
    value: "equity",
    dataAid: "equity",
  },
  {
    label: "Debt",
    value: "debt",
    dataAid: "debt",
  },
  {
    label: "Hybrid",
    value: "hybrid",
    dataAid: "hybrid",
  },
];

export const INVESTMENT_TYPES = [
  {
    label: "One-time",
    value: "onetime",
    dataAid: "oneTime",
  },
  {
    label: "SIP",
    value: "sip",
    dataAid: "sip",
  },
];

export const INVESTMENT_TYPE_EVENT_MAPPER = {
  sip: "sip",
  onetime: "one time",
};

export const ORDER_STATUS = {
  SUCCESS: "success",
  DEFAULT: "default",
};

export const ORDER_SUCCESS_STATUS = {
  [TRANSACTION_TYPE.REDEMPTION]: STEP_STATUS.UNIT_DEDUCTED,
  [TRANSACTION_TYPE.SWITCH]: STEP_STATUS.UNIT_ALLOTED,
  [TRANSACTION_TYPE.SWITCHIN]: STEP_STATUS.UNIT_ALLOTED,
  [TRANSACTION_TYPE.PURCHASE]: STEP_STATUS.UNIT_ALLOTED,
};

export const RTA_TTYPE_MAPPER = {
  [TRANSACTION_TYPE.REDEMPTION]: "withdraw",
  [TRANSACTION_TYPE.SWITCH]: "switch",
  [TRANSACTION_TYPE.SWITCHIN]: "switch",
  [TRANSACTION_TYPE.PURCHASE]: "invest",
};

export const YOUR_ORDERS_DEFAULT_FILTER_DATA = {
  0: {},
  1: {},
};

export const YOUR_ORDERS_DEFAULT_DATE_FILTER_DATA = {
  0: { startDate: "", endDate: "", count: 0 },
  1: { startDate: "", endDate: "", count: 0 },
};


export const YOUR_ORDERS_FILTER_MAPPER = {
  INVESTMENT_TYPES : 'order_type',
  ORDER_TYPES: 'ttype',
  CATEGORIES: 'fisdom_category_v2'
}

export const YOUR_ORDERS_FILTER_OPTIONS_MAPPER = {
  [YOUR_ORDERS_FILTER_MAPPER.INVESTMENT_TYPES] : INVESTMENT_TYPES,
  [YOUR_ORDERS_FILTER_MAPPER.ORDER_TYPES] : ORDER_TYPES,
  [YOUR_ORDERS_FILTER_MAPPER.CATEGORIES] : CATEGORIES
}

export const TRANSACTION_TYPE_EVENTS_MAPPER = {
  purchase: "purchase",
  divreinvest: "dividend",
  transferin: "change of broker",
  redemption: "withdraw",
  divpayout: "dividend",
  transferout: "change of broker",
  switchin: "switch",
  switch: "switch",
};

export const DEFAULT_YOUR_ORDERS_STORAGE = {
  filterData: YOUR_ORDERS_DEFAULT_FILTER_DATA,
  activeTab: 0,
  date: YOUR_ORDERS_DEFAULT_DATE_FILTER_DATA
};

export const DEFAULT_YOUR_FUNDS_STORAGE = {
  fundHouses: [],
  categoryData: [],
  sort: {},
};

export const DEFAULT_VIEW_ALL_SIPS_STORAGE = {
  sipStatus: "",
  categoryData: [],
  sort: {},
};

export const SIP_DATA = {
  init : {
    rightTitle: "Mandate pending",
    rightTitleColor: "foundationColors.secondary.mango.400",
    rightIcon: "inprogress_icon.svg",
  },
  mandate_approved: {
    rightTitle: "Mandate approved",
    rightTitleColor: "foundationColors.secondary.mango.400",
    rightIcon: "inprogress_icon.svg",
  },
  active: {
    rightTitle: "Active",
    rightTitleColor: "foundationColors.secondary.profitGreen.400",
    rightIcon: "successfull.svg",
  },
  pause_requested: {
    rightTitle: "Pause in progress",
    rightTitleColor: "foundationColors.secondary.mango.400",
    rightIcon: "paused_icon.svg",
  },
  paused: {
    rightTitle: "Paused",
    rightTitleColor: "foundationColors.secondary.coralOrange.400",
    rightIcon: "paused.svg",
  },
  cancellation_requested: {
    rightTitle: "CANCEL In Progress",
    rightTitleColor: "foundationColors.secondary.mango.400",
    rightIcon: "cancel_icon.svg",
  },
  cancelled: {
    rightTitle: "Cancelled",
    rightTitleColor: "foundationColors.secondary.lossRed.400",
    rightIcon: "cancelled.svg",
  },
  resume_requested: {
    rightTitle: "Resume in progress",
    rightTitleColor: "foundationColors.secondary.mango.400",
    rightIcon: "inprogress_icon.svg",
  },
  restart_requested: {
    rightTitle: "Restart in progress",
    rightTitleColor: "foundationColors.secondary.mango.400",
    rightIcon: "inprogress_icon.svg",
  },
  edited: {
    rightTitle: "Edit in progress",
    rightTitleColor: "foundationColors.secondary.mango.400",
    rightIcon: "inprogress_icon.svg",
  },
};

export const SIP_STEPS_MAPPER = {
  pause_requested: [
    {
      title: SIP_STATUS_DETAILS.pauseRequestedStatus.step1.text,
      variant: "SUCCESSFUL"
    },
    {
      title: SIP_STATUS_DETAILS.pauseRequestedStatus.step2.text,
      variant: "DEFAULT"
    }
  ],
  paused: [
    {
      title: SIP_STATUS_DETAILS.pauseRequestedStatus.step1.text,
      variant: "SUCCESSFUL"
    },
    {
      title: SIP_STATUS_DETAILS.pauseRequestedStatus.step2.text,
      variant: "SUCCESSFUL"
    }
  ],
  cancellation_requested: [
    {
      title: SIP_STATUS_DETAILS.cancelRequestedStatus.step1.text,
      variant: "SUCCESSFUL"
    },
    {
      title: SIP_STATUS_DETAILS.cancelRequestedStatus.step2.text,
      variant: "DEFAULT"
    }
  ],
  cancelled: [
    {
      title: SIP_STATUS_DETAILS.cancelRequestedStatus.step1.text,
      variant: "SUCCESSFUL"
    },
    {
      title: SIP_STATUS_DETAILS.cancelRequestedStatus.step2.text,
      variant: "SUCCESSFUL"
    }
  ]
}

export const FILTER_TAB_OPTIONS = [
  { id: 1, label: 'Category', testIdSuffix: 'category' },
  { id: 2, label: 'Status', testIdSuffix: 'status' },
];

export const FILTER_SIP_STATUS_OPTIONS_MAPPER = [
  {
    label: "Active",
    dataAid: "active",
    value: "active"
  },
  {
    label: "Paused",
    dataAid: "paused",
    value: "paused"
  },
  {
    label: "Cancelled",
    dataAid: "cancelled",
    value: "cancelled"
  }
]

export const SIP_MANAGER_SORT_DATA = [
  {
    title: "SIP amount",
    titleDataAid: "sipAmount",
    value: "sipAmount",
    contents: [
      {
        label: "High to low",
        value: "amountHighToLow",
        order: "desc",
        labelDataAid: "highToLow",
        type: "amount",
      },
      {
        label: "Low to high",
        value: "amountLowToHigh",
        order: "asc",
        labelDataAid: "lowToHigh",
        type: "amount",
      },
    ],
  },
  {
    title: "SIP date",
    titleDataAid: "sipDate",
    value: "sipDate",
    contents: [
      {
        label: "1st to 31st",
        value: "date1stto31st",
        labelDataAid: "first",
        type: "sip_day",
        order: "asc",
        id: "sipDate",
      },
      {
        label: "Purchased/modified",
        value: "purchasedModified",
        labelDataAid: "purchasedModified",
        id: "sipDate",
        type: "dt_created",
        order: "desc",
      }
    ],
  },
];

export const SIP_STATUS_MAPPER = {
  INIT: 'init',
  MANDATE_APPROVED: 'mandate_approved',
  ACTIVE: 'active',
  PAUSE_REQUESTED: 'pause_requested',
  PAUSED: 'paused',
  CANCELLATION_REQUESTED: 'cancellation_requested',
  CANCELLED: 'cancelled',
  RESUME_REQUESTED: "resume_requested",
  RESTART_REQUESTED: "restart_requested",
  EDITED: 'edited',
}

export const SIP_STATUS_INFO_CARD_MAPPER = {
  [SIP_STATUS_MAPPER.RESUME_REQUESTED]: {
    title: SIP_STATUS_DETAILS.resumeSipRequested.title,
    subtitle: SIP_STATUS_DETAILS.resumeSipRequested.subtitle,
    dataAid: SIP_STATUS_DETAILS.resumeSipRequested.dataAid
  },
  [SIP_STATUS_MAPPER.RESTART_REQUESTED] : {
    title: SIP_STATUS_DETAILS.restartSipRequested.title,
    subtitle: SIP_STATUS_DETAILS.restartSipRequested.subtitle,
    dataAid: SIP_STATUS_DETAILS.restartSipRequested.dataAid
  },
}

export const MANDATE_SCREEN_STATUS = [
  SIP_STATUS_MAPPER.INIT,
  SIP_STATUS_MAPPER.MANDATE_APPROVED,
  SIP_STATUS_MAPPER.ACTIVE,
];

export const SIP_ACTION_MAPPER = {
  PAUSE: "pause",
  CANCEL: "cancel",
  RESUME: "resume",
  RESTART: "restart",
  EDIT: "edit"
}